import RegPage from './RegPage';

export default RegPage;
